module.exports = __webpack_public_path__ + "img/coupon_list.5b06d971.svg";